export default "__VITE_ASSET__28907ec0__"